import * as React from 'react';

import type { LearnerStatus } from '@coursera-web/enterprise-admin-learners';

import { getDefaultUserFilterPreset } from 'bundles/enterprise-admin-user-filters/constants';
import type { SavedAdminFilter } from 'bundles/enterprise-admin-user-filters/types';

type User = {
  userId: string;
  fullName: string;
  email: string;
  status?: LearnerStatus;
  externalId?: string;
};

export type UserFilterContextType = {
  selectedUsers: User[];
  setSelectedUsers: (value: User[]) => void;
  userFilter: SavedAdminFilter;
  setUserFilter: React.Dispatch<React.SetStateAction<SavedAdminFilter>>;
  contentAssignmentFilter?: SavedAdminFilter;
  setContentAssignmentFilter: React.Dispatch<React.SetStateAction<SavedAdminFilter | undefined>>;
  contentAssignmentProgramId?: string;
  setContentAssignmentProgramId: React.Dispatch<React.SetStateAction<string | undefined>>;
  contentAssignmentSearch: string;
  setContentAssignmentSearch: React.Dispatch<React.SetStateAction<string>>;
};

export const UserFilterContext = React.createContext<UserFilterContextType | undefined>(undefined);

export const UserFilterProvider: React.LegacyFunctionComponentWithChildren<{ defaultFilter?: SavedAdminFilter }> = ({
  defaultFilter = getDefaultUserFilterPreset(),
  children,
}) => {
  // @ts-expect-error TS2345 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  const [userFilter, setUserFilter] = React.useState<SavedAdminFilter>(defaultFilter);
  const [selectedUsers, setSelectedUsers] = React.useState<User[]>([]);
  const [contentAssignmentFilter, setContentAssignmentFilter] = React.useState<SavedAdminFilter | undefined>(undefined);
  const [contentAssignmentProgramId, setContentAssignmentProgramId] = React.useState<string | undefined>(undefined);
  const [contentAssignmentSearch, setContentAssignmentSearch] = React.useState<string>('');
  return (
    <UserFilterContext.Provider
      value={{
        selectedUsers,
        setSelectedUsers,
        userFilter,
        setUserFilter,
        contentAssignmentFilter,
        setContentAssignmentFilter,
        contentAssignmentProgramId,
        setContentAssignmentProgramId,
        contentAssignmentSearch,
        setContentAssignmentSearch,
      }}
    >
      {children}
    </UserFilterContext.Provider>
  );
};

export const useUserFilter = () => {
  const context = React.useContext(UserFilterContext);
  if (context === undefined) {
    throw new Error('useUserFilter must be used within a UserFilterContext');
  }
  return context;
};
